import { Navigate, useLocation, Link } from "react-router-dom";
import { useAuth, homeForRole } from "@/context/AuthContext";

export const Loading = ({ label = "Caricamento in corso…" }) => (
    <div role="status" aria-live="polite" className="mx-auto max-w-6xl px-4 py-16 text-edi-muted" data-testid="loading-indicator">
        {label}
    </div>
);

export const RequireAuth = ({ roles, children }) => {
    const { user } = useAuth();
    const location = useLocation();
    if (user === undefined) return <Loading />;
    if (!user) return <Navigate to="/accedi" replace state={{ from: location.pathname + location.search }} />;
    if (roles && !roles.includes(user.role)) {
        return (
            <section className="mx-auto max-w-3xl px-4 py-16" data-testid="access-denied">
                <h1 className="text-3xl font-extrabold">Accesso negato</h1>
                <p className="mt-4">Non hai i permessi per visualizzare questa pagina.</p>
                <Link to={homeForRole(user.role)} className="btn-primary mt-6" data-testid="access-denied-home-link">Torna alla tua area</Link>
            </section>
        );
    }
    return children;
};
